import { Controller } from '@hotwired/stimulus';

export default class ExportChannelController extends Controller {
  static values = {
    channel: String,
    url: String,
  };

  connect() {
    this.subscription = App.cable.subscriptions.create(
      { channel: this.channelValue },
      { received: this.#refresh.bind(this) }
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }

  async #refresh() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) return;

    const html = await response.text();
    this.element.innerHTML = html;
  }
}
